import { EntitlementStatementDocumentQuery } from '@dreryk/egabinet-patient-frontend-api';

import { performCqrsQueryGet } from '@dreryk/command-query-react-common';
import { printDocumentAsPdf } from '@dreryk/react-common';

export const printEntitlementStatement = async (
   entitlementStatementId: number,
   printWithExplanationsAndNotice: boolean
): Promise<void> => {
   const result = await performCqrsQueryGet<{ data: string }>(() => {
      const query = new EntitlementStatementDocumentQuery();
      query.entitlementStatementId = entitlementStatementId;
      query.explanationsAndNotice = printWithExplanationsAndNotice;
      return query;
   });
   if (result) {
      await printDocumentAsPdf({
         base64: result.data,
      });
   }
};
